<template lang="pug">
  #program-admin-log
    WtTitle(card-title semibold) Program Log
    ContentLoader(:height="120" v-if="contentLoader")
      rect(x="0", y="0", rx="4", ry="4", width="50%", height="15%")
      rect(x="0", y="20%", rx="4", ry="4", width="100%", height="80%")
    WtEntityTable.program-admin-log-table(
      v-if="!contentLoader"
      title=""
      striped
      :data="logs.data"
      empty-message="No actions logged."
      :pagination-object="logs.pagination"
      :fetch-action="fetchAction"
      default-sort-field="action"
      :loading="isLoading"
    )
      BTableColumn(field="action" label="Action" v-slot="column")
        .columns
          .column.is-narrow
            BIcon(
              :icon="actionIcon(column.row.action).icon"
              :type="actionIcon(column.row.action).type"
            )
          .column
            .action-text {{ column.row.action }}
      BTableColumn(field="created" label="Time" v-slot="column")
        span {{ date(column.row.created, "DATE_TIME_FORMAT").formatted }}
</template>

<script>
import { mapActions } from "vuex";
import { ContentLoader } from "vue-content-loader";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import WtTitle from "@@/WtTitle/WtTitle";
import WtEntityTable from "@@/WtEntityTable/WtEntityTable";

export default {
  name: "ProgramAdminLog",

  components: {
    WtTitle,
    WtEntityTable,
    ContentLoader
  },

  mixins: [dateUtilityMixin],

  data() {
    return {
      logs: { data: [], pagination: {} },
      isLoading: false,
      contentLoader: true
    };
  },

  async mounted() {
    await this.fetchAction();
    this.contentLoader = false;
  },

  methods: {
    ...mapActions("program", ["programAdminLog"]),

    fetchAction(payload) {
      this.isLoading = true;
      return this.programAdminLog(payload).then(response => {
        this.isLoading = false;
        this.logs = response;
      });
    },

    actionIcon(action) {
      const iconInfo = {
        created: {
          icon: "check-bold",
          type: "is-success"
        },
        updated: {
          icon: "update",
          type: "is-info"
        },
        deleted: {
          icon: "delete",
          type: "is-danger"
        },
        download: {
          icon: "download",
          type: "is-action"
        },
        default: {
          icon: "shoe-print",
          type: "is-warning"
        }
      };

      if (/created/.test(action)) return iconInfo.created;
      if (/updated/.test(action)) return iconInfo.updated;
      if (/deleted/.test(action)) return iconInfo.deleted;
      if (/download/.test(action)) return iconInfo.download;

      return iconInfo.default;
    }
  }
};
</script>

<style lang="sass" scoped></style>
